<div class="image-container">
  <div *ngIf="!userData?.userImgUrl" class="profile-picture img-size">
    <b [class.font-large]="font === 'large'">{{ initials }}</b>
  </div>
  <img
    *ngIf="userData?.userImgUrl"
    [src]="userData?.userImgUrl"
    class="rounded-circle z-depth-2 img-size"
    alt="100x100"
  />
  <ng-content></ng-content>
</div>
